import { usePrices } from '@/domain/prices/prices/hooks';
import { Banner, Typography, SpaceBetween } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';

const Texts = styled(SpaceBetween)`
  flex: 1;
`;

export const Messages = () => {
  const { messages } = usePrices();
  if (!messages) return null;
  return messages.map((message, index) => (
    <Banner key={index} $type={message.level}>
      <Texts direction="y">
        {message.texts.map((text, _) => (
          <Typography key={_} dangerouslySetInnerHTML={{ __html: text }} />
        ))}
      </Texts>
    </Banner>
  ));
};
